var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-file-input js-file-input has-file",
      class: { "has-file": _vm.showRemovedBtn }
    },
    [
      !_vm.disabled
        ? _c(
            "div",
            {
              staticClass: "c-file-input__indicator",
              on: { click: _vm.selectFile }
            },
            [_vm._m(0)]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "c-file-input__label js-file-input__label",
          attrs: { for: "inputfile" }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.theFileName))]),
          _vm._v(" "),
          _c("input", {
            ref: "fileInput",
            staticClass: "c-file-input__field js-file-input__field",
            attrs: { disabled: _vm.disabled, type: "file", name: _vm.name },
            on: { change: _vm.fileChangeHandler }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "c-file-input__remove js-file-input__remove",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.clearFileHandler($event)
            }
          }
        },
        [
          !_vm.disabled
            ? _c(
                "span",
                {
                  staticClass:
                    "c-file-input__remove__icon c-icon c-icon--remove-circle"
                },
                [_c("i", { staticClass: "fas fa-minus-circle" })]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "c-file-input__indicator__icon c-icon c-icon--attach" },
      [_c("i", { staticClass: "fas fa-upload" })]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53154032", { render: render, staticRenderFns: staticRenderFns })
  }
}